import $ from "jquery";
import React, { useCallback } from "react";

const MinifyMenu = () => {
  const $body = $("body");

  const toggle = useCallback(() => {
    if (!$body.hasClass("menu-on-top")) {
      $body.toggleClass("minified");
      $body.removeClass("hidden-menu");
      $("html").removeClass("hidden-menu-mobile-lock");
    }
  }, [$body]);

  return (
    <span
      className="minifyme"
      data-action="minifyMenu"
      onClick={() => toggle()}
    >
      <i className="fa fa-arrow-circle-left hit" />
    </span>
  );
};

export default MinifyMenu;
